var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrensaL3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 30,
    viewBox: "0 0 72 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2653_600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2653_600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3656 0H0V30H71.3656V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2653_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2561 20.793H44.9282V11.457H41.4199V9.12085H50.7561V11.457H47.2561V20.793ZM61.2179 9.12085L57.3842 20.793H55.048L51.2305 9.12085H53.8841L56.212 16.9105L58.5481 9.12085H61.2179ZM64.3658 20.793H62.0298V9.12085H66.7019C67.1304 9.12085 67.543 9.17655 67.9391 9.2875C68.3351 9.39898 68.7055 9.55638 69.0503 9.75977C69.3948 9.96329 69.7095 10.2073 69.9945 10.4923C70.2794 10.7773 70.5236 11.0933 70.727 11.4405C70.9305 11.788 71.0879 12.1598 71.1992 12.5557C71.3102 12.9519 71.3659 13.3644 71.3659 13.7929C71.3659 14.4334 71.2439 15.0371 70.9997 15.604C70.7554 16.1711 70.4218 16.6663 69.9984 17.0894C69.5753 17.5127 69.0799 17.8464 68.513 18.0907C67.946 18.3349 67.3422 18.457 66.7019 18.457H64.3658V20.793ZM64.3658 11.4569V16.129H66.7019C67.0219 16.129 67.3232 16.068 67.6054 15.9458C67.8875 15.8238 68.1345 15.657 68.3461 15.4453C68.5577 15.2337 68.7245 14.9854 68.8467 14.7005C68.9688 14.4156 69.0299 14.1133 69.0299 13.7929C69.0299 13.4728 68.9688 13.1702 68.8467 12.8855C68.7245 12.6006 68.5577 12.3522 68.3461 12.1407C68.1345 11.929 67.8875 11.7621 67.6054 11.64C67.3232 11.5179 67.0219 11.4569 66.7019 11.4569H64.3658Z",
    fill: "#123B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.193 24.6266C15.8799 24.6266 11.5574 20.3041 11.5574 14.9909C11.5574 9.67764 15.8799 5.3552 21.193 5.3552C26.5061 5.3552 30.8286 9.67764 30.8286 14.9909C30.8286 20.3041 26.5061 24.6266 21.193 24.6266ZM21.193 0C12.9138 0 6.20215 6.71167 6.20215 14.9909C6.20215 15.5054 6.22832 16.0141 6.27893 16.5153C6.43177 16.5049 6.58587 16.4992 6.74142 16.4992C10.4645 16.4992 13.4826 19.5173 13.4826 23.2404C13.4826 24.6577 13.045 25.9724 12.298 27.0578C14.7862 28.895 17.8625 29.9817 21.193 29.9817C29.4722 29.9817 36.1839 23.2702 36.1839 14.9909C36.1839 6.71167 29.4722 0 21.193 0Z",
    fill: "#2497FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28027 16.5157C6.43278 16.5054 6.58781 16.4998 6.74289 16.4998C10.4647 16.4998 13.4836 19.5179 13.4836 23.241C13.4836 24.6574 13.0468 25.9714 12.2998 27.0567C8.98635 24.6101 6.71706 20.8324 6.28027 16.5157Z",
    fill: "#123B80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27866 16.5154C2.77077 16.7533 0 19.6732 0 23.2405C0 26.9638 3.01817 29.9819 6.74088 29.9819C9.04698 29.9819 11.0832 28.8239 12.2975 27.0579C8.98447 24.6117 6.7159 20.8345 6.27866 16.5154Z",
    fill: "#F9CF1C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2653_600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.3656,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrensaL3);
export default __webpack_public_path__ + "static/media/Prensa-L-3.c25651ac3c91873da65c6f5e6a5a8f78.svg";
export { ForwardRef as ReactComponent };